import React from 'react';
import Modal from 'simple-react-modal';

import TransparentLoader from '../Loaders/TransparentLoader';
import Pagination from '../../pages/Anchors/Pagination';
import BecomeAnchorBanner from '../../assets/AuditionsPage/become-anchor-banner.jpg';

import Audition from './Audition';
import styles from './css/Auditions.module.css';
import AuditionSortingFilter from './AuditionSortingFilter';


const AmateurAuditionsForm = React.lazy(() => import('./AmateurAuditionsForm'));


class Auditions extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = { toggleAmateurAuditionForm: false };
  }

  onAuditionFormToggle = () => {
    this.setState({ toggleAmateurAuditionForm: !this.state.toggleAmateurAuditionForm });
  };

  render() {
    const { toggleAmateurAuditionForm } = this.state;
    const {
      auditions,
      loadMore,
      handleArchiveClick,
      sortOrder,
      setSortOrder,
      currentPageNumber,
      totalNumberOfPages,
    } = this.props;

    return (
      <div className={styles.auditionIndexView}>
        <div className={styles.container}>
          <div className={styles.topSection}>
            <div className={styles.borderWrapper}>
              <div className={styles.titleOutlineGradient}>
                <h1 className={styles.auditionHeaderTitle}>AMATEUR AUDITIONS</h1>
              </div>
            </div>
            <div className={styles.auditionFormToggleWrapper}>
              <div className={styles.auditionFormToggleContainer}>
                <h1 className={styles.auditionFormCta}>Become a Naked News Anchor</h1>
                <button className={styles.formToggle} onClick={this.onAuditionFormToggle}>Click Here</button>
              </div>
            </div>
            <React.Suspense fallback={<TransparentLoader />}>
              <Modal
                closeOnOuterClick={true}
                containerStyle={{
                  width: '100%',
                  padding: '0',
                  marginTop: '100px',
                  background: 'transparent',
                }}
                show={toggleAmateurAuditionForm}
              >
                <div>
                  <AmateurAuditionsForm handleAuditionFormToggle={this.onAuditionFormToggle} />
                </div>
              </Modal>
            </React.Suspense>
          </div>
          <div className={styles.filterContainer}>
            <AuditionSortingFilter setSortOrder={setSortOrder} sortOrder={sortOrder} />
          </div>
          <div className={styles.auditionRows}>
            {
              auditions.map((audition) => (
                <Audition
                  key={audition?.slug + audition?.auditionId + audition?.programId}
                  audition={audition}
                  handleArchiveClick={handleArchiveClick}
                />
              ))
            }
          </div>
          <div className={styles.paginationContainer}>
            <Pagination page={currentPageNumber} totalPages={totalNumberOfPages} onPageChange={loadMore} />
          </div>
          <div className={styles.becomeAnchorCtaBannerContainer}>
            <button className={styles.becomeAnchorCtaBannerButton} onClick={this.onAuditionFormToggle}>
              <img alt="BECOME AN ANCHOR" className={styles.becomeAnchorCtaBanner} src={BecomeAnchorBanner} />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Auditions;
